<script>
import Cadastrar from '@/components/alerta/VCadastrar'

export default {
  name: 'CadastroAlerta',
  components: {
    Cadastrar
  },
}
</script>

<template>
  <Cadastrar/>
</template>

<style scoped>
</style>
